<template>
  <div v-if="shown" class="modal-filter-wrap">
    <div class="modal-filter" :class="modalClass">
      <div class="modal-filter__inner">
        <img src="/img/ic_attention.svg" alt="">
        <p class="modal-filter__inner-text">
          <slot></slot>
        </p>
      </div>
      <div class="modal-filter-btns">
        <button class="btn greenBtnCondition modal-filter-btn" @click="$emit('ok', context)">{{ okText }}</button>
        <button class="btn modal-filter-btn transp" @click="$emit('cancel')">{{ cancelText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alarm-modal',
  props: {
    modalClass: [Array, Object, String],
    okText: {
      type: String,
      default: 'Продолжить'
    },
    cancelText: {
      type: String,
      default: 'Вернуться'
    }
  },
  data: () => ({
    shown: false,
    context: null
  }),
  methods: {
    show (context) {
      this.shown = true
      this.context = context
    },
    hide () {
      this.shown = false
      this.context = null
    }
  }
}
</script>